// Generated from the printed canvas kit (canvas_kit.py: SPINE, SCEPTIC_Q, OPT). One source for titles, steps, minutes and chains.
// pulls and feeds: { no } is a canvas (0 is the Case Card); { list } is a named list; { text } is plain words.
export const SPINE = {
  0: {
    no: 0,
    name: "Case Card",
    arc: "Make the case",
    day: 1,
    module: 1,
    question: "Which real case will I carry?",
    sceptic: "Your partner",
    minutes: "45 min before Day 1, 15 min in Module 1",
    steps: [
      { title: "Context", minutes: 5 },
      { title: "Priority journey", minutes: 10 },
      { title: "Sponsor", minutes: 5 },
      { title: "Baseline numbers", minutes: 15 },
      { title: "The AI idea in the air", minutes: 5 },
      { title: "The people", minutes: 5 },
    ],
    pulls: [{ text: "You: your own real case" }],
    feeds: [{ no: 1 }, { no: 2 }, { no: 3 }, { no: 4 }, { no: 7 }, { no: 8 }, { no: 9 }, { list: "Evidence Gaps" }, { list: "Ledger" }],
    sceptic_questions: [
      "How would you know this journey is broken?",
      "Which two KPIs is your sponsor measured on?",
      "Which of your baseline numbers is still a guess?",
    ],
  },
  1: {
    no: 1,
    name: "Maturity Snapshot",
    arc: "Make the case",
    day: 1,
    module: 2,
    question: "Where do we really stand?",
    sceptic: "Business head",
    minutes: 23,
    steps: [
      { title: "Score alone with proof and a tag", minutes: 9 },
      { title: "Compare at the table and set targets", minutes: 9 },
      { title: "Weights, priority gap, confirm or override", minutes: 5 },
    ],
    pulls: [{ no: 0, note: "B and D" }],
    feeds: [{ no: 3 }, { no: 5 }, { no: 6 }, { no: 7 }, { no: 9 }, { list: "Ledger" }, { list: "Evidence Gaps" }],
    sceptic_questions: [
      "What would I see in the business if this were a 3?",
      "Who else confirms this level, or is it your team's view alone?",
      "Which one gap, once closed, changes what we can launch?",
    ],
  },
  2: {
    no: 2,
    name: "Journey and Trust Map",
    arc: "Make the case",
    day: 1,
    module: 3,
    question: "Where will AI touch the customer, and what do we do first?",
    sceptic: "IT and Data",
    minutes: 20,
    steps: [
      { title: "Stages and pain points with tags", minutes: 7 },
      { title: "Tick S, D, R and name the human role", minutes: 5 },
      { title: "AI opportunity and type", minutes: 5 },
      { title: "Number up to five candidates", minutes: 3 },
    ],
    pulls: [{ no: 0, note: "B and E" }],
    feeds: [{ no: 3 }, { no: 4 }, { no: 5 }, { no: 6 }, { no: 7 }, { no: 9 }, { list: "Ledger" }, { list: "Evidence Gaps" }],
    sceptic_questions: [
      "Which pain points are in a report, and which are your team's view?",
      "Where does your top pick's data live, and who owns it?",
      "What would it take to run this every day, for every customer?",
    ],
  },
  3: {
    no: 3,
    name: "Use Case Prioritisation",
    arc: "Make the case",
    day: 1,
    module: 3,
    question: "Where will AI touch the customer, and what do we do first?",
    sceptic: "IT and Data",
    minutes: 32,
    steps: [
      { title: "Screen all five on Value and Feasibility", minutes: 10 },
      { title: "Plot and name the top three", minutes: 5 },
      { title: "Test the top three (Scalability, Risk, Trust, Human)", minutes: 10 },
      { title: "Total, flag and name the data", minutes: 4 },
      { title: "Top pick and second pick", minutes: 3 },
    ],
    pulls: [{ no: 2, note: "candidates" }, { no: 1, note: "Data and AI level" }, { no: 0, note: "E, through the candidate marked on Canvas 2" }],
    feeds: [{ no: 4 }, { no: 5 }, { no: 6 }, { no: 7 }, { no: 8 }, { no: 9 }, { list: "Ledger" }, { list: "Evidence Gaps" }],
    sceptic_questions: [
      "Which pain points are in a report, and which are your team's view?",
      "Where does your top pick's data live, and who owns it?",
      "What would it take to run this every day, for every customer?",
    ],
  },
  4: {
    no: 4,
    name: "Value and Investment Case",
    arc: "Make the case",
    day: 1,
    module: 4,
    question: "What is it worth, and would the CFO fund it?",
    sceptic: "CFO",
    minutes: 35,
    steps: [
      { title: "Copy top pick, journey, sponsor KPIs", minutes: 3 },
      { title: "Four value rows", minutes: 10 },
      { title: "The money line", minutes: 6 },
      { title: "Investment side and contingency", minutes: 6 },
      { title: "Two-Story Test", minutes: 4 },
      { title: "Value story", minutes: 6 },
    ],
    pulls: [{ no: 3, note: "top pick" }, { no: 2, note: "journey" }, { no: 0, note: "C and D" }],
    feeds: [{ no: 5 }, { no: 7 }, { no: 8 }, { no: 9 }, { list: "Evidence Gaps" }, { list: "Ledger" }],
    sceptic_questions: [
      "Which of these numbers could I verify from a system today?",
      "What is the cost range, including guardrails and training, and what contingency have you kept?",
      "If the benefit is half your low case, do we still fund Phase 1?",
    ],
  },
  5: {
    no: 5,
    name: "AICX Blueprint",
    arc: "Make it buildable",
    day: 2,
    module: 5,
    question: "What has to exist behind the experience?",
    sceptic: "IT and Data",
    minutes: 32,
    steps: [
      { title: "Riskiest trust moment and human involvement", minutes: 4 },
      { title: "Trust-moment strip", minutes: 6 },
      { title: "Data and platform", minutes: 7 },
      { title: "AI layers", minutes: 6 },
      { title: "Operating model", minutes: 5 },
      { title: "Vision last", minutes: 4 },
    ],
    pulls: [{ no: 1 }, { no: 2 }, { no: 3 }, { no: 4 }],
    feeds: [{ no: 6 }, { no: 7 }, { no: 8 }, { no: 9 }, { list: "Ledger" }, { list: "Evidence Gaps" }],
    sceptic_questions: [
      "Where does each data item come from, and who owns it?",
      "What happens to the customer when a source is late or wrong?",
      "Build, buy or reuse: who runs each layer a year from now?",
    ],
  },
  6: {
    no: 6,
    name: "Governance and Trust Guardrails",
    arc: "Make it buildable",
    day: 2,
    module: 6,
    question: "Which guardrails must be in place, and who owns them?",
    sceptic: "Risk and Compliance",
    minutes: 20,
    steps: [
      { title: "Tier and controls in place", minutes: 3 },
      { title: "Rate four areas with proof", minutes: 7 },
      { title: "Handover design", minutes: 4 },
      { title: "One action and owner per area", minutes: 3 },
      { title: "Riskiest gap and launch conditions", minutes: 3 },
    ],
    pulls: [{ no: 1 }, { no: 2 }, { no: 3 }, { no: 5 }],
    feeds: [{ no: 7 }, { no: 8 }, { no: 9 }, { list: "Ledger" }],
    sceptic_questions: [
      "Which of these would I have to sign, and what evidence would I see?",
      "When the first wrong decision happens, who finds out, and how fast?",
      "Which existing obligation does this touch, and who has checked?",
    ],
  },
  7: {
    no: 7,
    name: "Capability and Change",
    arc: "Make it happen",
    day: 2,
    module: 7,
    question: "What must people be able to do, and why would they?",
    sceptic: "Frontline",
    minutes: 20,
    steps: [
      { title: "List two to four roles", minutes: 3 },
      { title: "Today, needed and gap type", minutes: 7 },
      { title: "Lever and first rehearsal", minutes: 5 },
      { title: "Change owner and One Story Check", minutes: 3 },
      { title: "One sentence for the frontline", minutes: 2 },
    ],
    pulls: [{ no: 1 }, { no: 2 }, { no: 3 }, { no: 4 }, { no: 5 }, { no: 6 }, { no: 0, note: "C" }],
    feeds: [{ no: 8 }, { no: 9 }, { list: "Ledger" }],
    sceptic_questions: [
      "What changes in my day, and who asked me?",
      "What happens to my job when this works?",
      "When the tool is wrong, what do I do, and will I be blamed?",
    ],
  },
  8: {
    no: 8,
    name: "Roadmap and Gates",
    arc: "Make it happen",
    day: 2,
    module: 8,
    question: "In what order, and what releases the next step?",
    sceptic: "CFO",
    minutes: 26,
    steps: [
      { title: "Pull items from Canvases 3 to 7 and the Evidence Gaps list", minutes: 5 },
      { title: "Sort into phases by dependency and owner", minutes: 7 },
      { title: "Write each gate and its tranche", minutes: 6 },
      { title: "Top three delivery risks", minutes: 5 },
      { title: "Check Phase 1", minutes: 3 },
    ],
    pulls: [{ no: 3 }, { no: 4 }, { no: 5 }, { no: 6 }, { no: 7 }, { list: "Evidence Gaps" }, { no: 0, note: "C" }],
    feeds: [{ no: 9 }, { list: "Ledger" }, { list: "Evidence Gaps" }],
    sceptic_questions: [
      "What do I fund now, and what evidence releases the next tranche?",
      "What is the cost range with contingency, and what stops?",
      "Which dependency, if it slips, moves everything?",
      "Which Phase 1 gap stalls Phase 2?",
    ],
  },
  9: {
    no: 9,
    name: "Executive One-Pager",
    arc: "Make it happen",
    day: 2,
    module: 9,
    question: "Will the committee say yes, and to what exactly?",
    sceptic: "The whole panel",
    minutes: 20,
    steps: [
      { title: "The ask first", minutes: 4 },
      { title: "Why now, what it enables, how it scales", minutes: 5 },
      { title: "Value, key risk, one trade-off", minutes: 4 },
      { title: "Three objections with answers", minutes: 4 },
      { title: "Trim to three minutes and rehearse once", minutes: 3 },
    ],
    pulls: [{ no: 0, note: "C and D" }, { no: 1 }, { no: 2 }, { no: 3 }, { no: 4 }, { no: 5 }, { no: 6 }, { no: 7 }, { no: 8 }, { list: "Evidence Gaps" }, { list: "Ledger" }],
    feeds: [{ text: "the pitch" }, { list: "Panel Score" }, { list: "Plan" }],
    sceptic_questions: [
    ],
  },
};

// Fixed option lists (the workbook's hidden Lists tab): always chips or ticks, never free text.
export const OPT = {
  tag: ["M", "E", "G"],
  yesno: ["Yes", "No"],
  yes: ["Yes"],
  stance: ["Ally", "Neutral", "Sceptic"],
  stage: ["Idea", "Pilot", "Live"],
  aitype: ["scores", "writes", "acts"],
  risk: ["Low", "Medium", "High"],
  pzm: ["plus", "zero", "minus"],
  bbr: ["build", "buy", "reuse"],
  order: ["first", "next", "later"],
  ready: ["Yes", "Partial", "No"],
  involve: ["in the loop", "over the loop", "out of the loop"],
  rating: ["In place", "Partial", "Not yet"],
  status: ["Open", "Answered", "Closed"],
  direction: ["higher", "lower", "ceiling"],
  lever: ["training", "incentives", "leadership modelling", "feedback loops"],
  gaptype: ["Skill", "Trust", "Structure"],
  verdict: ["Pass", "Go back"],
  sdr: ["S", "D", "R"],
};

export const PANEL_LINE =
  "Each persona brings its question from the sceptic rounds. Log the reviewer role, the question you were asked in their words, the evidence that answers it, and who follows up. These rows feed the Plan.";
export const PANEL_FIRST_HEAD = "Reviewer role, and the objection in their words";
export const ARC_FAMILY = { 'Make the case': 'cyan', 'Make it buildable': 'purple', 'Make it happen': 'green' };
export const SIGNOFF_HEADS = ["Objection, in their words", "Evidence that answers it, and the cell it sits in", "Follow-up owner (a role)", "Status", "Star"];
